function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      // Get current value
      let quantity = Number(this.input.value);

      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      // Check for min & max
      if (this.input.getAttribute('min') > (quantity + change)) {
        return;
      }
      if (this.input.getAttribute('max')) {
        if (this.input.getAttribute('max') < (quantity + change)) {
          return;
        }
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);

      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-card--featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-card--featured-image-link');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableAdditionalImages() {
      // if hover slider is active, skip old hover logic
      if (this.classList.contains('enable-hover-slider')) {
        return;
      }

      let images = this.additional_images || [];
      let nav = this.additional_images_nav || [];
      let image_length = images.length;
      let image_container = this.querySelector('.product-card--featured-image-link');

      const mousemove = function (e) {
        if (!images.length) return;

        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];

        images.forEach((image, index) => {
          image?.classList?.remove('hover');
          nav?.[index]?.classList?.remove('active');
        });

        if (selimg) {
          selimg.classList.add('hover');
          nav?.[sel]?.classList?.add('active');
        }
      };

      const mouseleave = function (e) {
        if (!images.length) return;

        images.forEach((image, index) => {
          image?.classList?.remove('hover');
          nav?.[index]?.classList?.remove('active');
        });
      };

      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, { passive: true });
        image_container.addEventListener('touchmove', mousemove, { passive: true });
        image_container.addEventListener('touchend', mouseleave, { passive: true });
        image_container.addEventListener('mouseenter', mousemove, { passive: true });
        image_container.addEventListener('mousemove', mousemove, { passive: true });
        image_container.addEventListener('mouseleave', mouseleave, { passive: true });
      }

      images.forEach(function (image) {
        window.addEventListener('load', () => {
          if (window.lazySizes && window.lazySizes.loader) {
            lazySizes.loader.unveil(image);
          }
        });
      });
    }

    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener('mouseover', () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-card--featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          document.getElementById('Cart-Drawer')?.notesToggle();
          document.getElementById('Cart-Drawer')?.removeProductEvent();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || (panel.classList.contains('cart-item-drawer')) || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}

/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      let button = document.getElementById('cart-drawer-toggle');

      // Add functionality to buttons
      button.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.location.pathname.includes('/cart')) {
          return
        }
        if (this.getAttribute("data-cart-drawer-flag") === 'true') {
          window.location.href = '/cart';
          return;
        }
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        this.classList.add('active');
        this.focus();
        setTimeout(() => {
          this.querySelector('.product-recommendations--full')?.classList.add('active');
        });
        dispatchCustomEvent('cart-drawer:open');
      });

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', (event) => {
        this.refresh();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));

      this.notesToggle();
      this.removeProductEvent();
    }
    onChange(event) {
      if (event.target.classList.contains('qty')) {
        this.updateQuantity(event.target.dataset.index, event.target.value);
      }
    }
    removeProductEvent() {
      let removes = this.querySelectorAll('.remove');

      removes.forEach((remove) => {
        remove.addEventListener('click', (event) => {
          this.updateQuantity(event.target.dataset.index, '0');

          event.preventDefault();
        });
      });
    }
    getSectionsToRender() {
      return [
        {
          id: 'Cart-Drawer',
          section: 'cart-drawer',
          selector: '.cart-drawer'
        },
        {
          id: 'cart-drawer-toggle',
          section: 'cart-bubble',
          selector: '.thb-item-count'
        }];
    }
    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    notesToggle() {
      const notes_toggle = document.getElementById('order-note-toggle');

      if (!notes_toggle) {
        return;
      }

      notes_toggle.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.add('active');
      });
      notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
        el.addEventListener('click', (event) => {
          notes_toggle.nextElementSibling.classList.remove('active');
          this.saveNotes();
        });
      });
    }
    saveNotes() {
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': document.getElementById('mini-cart__notes').value
        })
      });
    }
    updateQuantity(line, quantity) {
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        ...{
          body
        }
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            if (parsedState.sections) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
            }
          }));

          this.removeProductEvent();
          this.notesToggle();
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });

          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
        });
    }
    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      let sections = 'cart-drawer,cart-bubble';
      fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
          }));

          this.removeProductEvent();
          this.notesToggle();
        });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});

class SizeTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.size-tab');
    this.fieldset = this.querySelector('#size-options');

    if (!this.tabs.length || !this.fieldset) return;

    // Initialize display based on active tab
    const activeTab = this.querySelector('.size-tab.active') || this.tabs[0];
    this.updateDisplay(activeTab.dataset.system.toLowerCase());

    // Add click listeners
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        this.tabs.forEach(t => t.classList.remove('active'));
        tab.classList.add('active');
        this.updateDisplay(tab.dataset.system.toLowerCase());
      });
    });
  }

  // updateDisplay(system) {
  //   this.fieldset.querySelectorAll('label').forEach(label => {
  //     label.querySelectorAll('span').forEach(span => {
  //       span.style.display = span.classList.contains(`size-${system}`) ? 'block' : 'none';
  //     });
  //   });
  // }

  updateDisplay(system) {
    this.fieldset.querySelectorAll('label').forEach(label => {
      label.querySelectorAll('span').forEach(span => {
        if (span.classList.contains(`size-${system}`)) {
          span.style.display = 'block';
          span.classList.add('data-variant-sizes')
          span.setAttribute('data-active-size', 'true');
        } else {
          span.style.display = 'none';
          span.classList.remove('data-variant-sizes')
          span.removeAttribute('data-active-size');
        }
      });
    });
  }
}

// Define the custom element
customElements.define('size-tabs-component', SizeTabs);


// Account drawer

/**
 *  @class
 *  @function AccountDrawer
 */
if (!customElements.get('account-drawer')) {
  class AccountDrawer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Use querySelectorAll to handle multiple triggers
      const profileButtons = document.querySelectorAll('[id="account-login-btn"]');
      const createButtons = document.querySelectorAll('[id="account-create-btn"]');
      const recoverButtons = document.querySelectorAll('[id="account-recover-btn"]');

      // Attach event listeners to all login buttons
      profileButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.openDrawer('account-login');
        });
      });

      // Attach event listeners to all create buttons
      createButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.openDrawer('account-create');
        });
      });

      // Attach event listeners to all recover buttons
      recoverButtons.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.openDrawer('account-recover');
        });
      });
    }

    openDrawer(sectionId) {
      document.body.classList.add('open-cc', 'open-account');
      this.classList.add('active');
      this.focus();
      dispatchCustomEvent('account-drawer:open');
      this.showSection(sectionId);
    }

    showSection(sectionId) {
      const allSections = this.querySelectorAll('.account-section');
      allSections.forEach((section) => section.classList.add('hidden'));

      const targetSection = this.querySelector(`#${sectionId}`);
      if (targetSection) {
        targetSection.classList.remove('hidden');
      }
    }
  }

  customElements.define('account-drawer', AccountDrawer);
}

/**
 *  @class
 *  @function CartItemQuickView
 */
if (!customElements.get('cart-item-quick-view')) {
  class CartItemQuickView extends HTMLElement {
    constructor() {
      super();
      this.onCartItemVariantChange = this.onCartItemVariantChange.bind(this);
      this.handleUpdateClick = this.handleUpdateClick.bind(this);
      this.onSizeChange = this.onSizeChange.bind(this);
      
      // Track initial state
      this.initialVariantId = null;
      this.initialSizeSelection = null;
      
      // Update result codes
      this.UPDATE_RESULT = {
        SUCCESS: 'success',
        INVENTORY_LIMIT: 'inventory_limit',
        ERROR: 'error'
      };
    }

    connectedCallback() {
      this.drawer = document.getElementById('Cart-Item-Drawer');
      this.body = document.body;
      this.productVariantId = this.dataset.productVariantId;
      this.productQuantity = this.dataset.productQuantity;
      this.productOption = JSON.parse(this.dataset.cartItemOption || '[]');

      this.addEventListener('click', this.setupEventListener.bind(this));
    }

    setupEventListener(e) {
      e.preventDefault();
      const productHandle = this.dataset.productHandle;
      if (!productHandle) return;

      let href = `${theme.routes.root_url}/products/${productHandle}?view=cart-item-drawer`;
      href = href.replace('//', '/');

      if (this.classList.contains('loading')) return;
      this.classList.add('loading');

      fetch(href, { method: 'GET' })
        .then((res) => {
          this.classList.remove('loading');
          return res.text();
        })
        .then((text) => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Cart-Item-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

          this.cartItemVariantConatiner = this.drawer.querySelector('.cart_item_variant');
          if (this.cartItemVariantConatiner) {
            this.cartItemVariantConatiner.insertAdjacentHTML('beforeend', this.formatProductOptions());
          }

          // CRITICAL: Restore the selected size state after rendering
          this.restoreSizeSelection();
          
          // Use requestAnimationFrame to ensure DOM is fully updated
          requestAnimationFrame(() => {
            // Capture initial state after restoration
            this.captureInitialState();
            
            // Attach size change listeners
            this.attachSizeChangeListeners();
            
            // Disable update button initially (after everything is set up)
            this.setUpdateButtonState(false);
          });
        })
        .catch((err) => {
          console.error('Quick view load failed:', err);
          this.classList.remove('loading');
        });
    }

    formatProductOptions() {
      if (!this.productOption) return '';
      const options = this.productOption.filter(opt => 
        !opt.name.toLowerCase().includes('size') && 
        opt.name !== '_selectedSizeSystem'
      );
      const capitalize = str => str.toLowerCase().replace(/^\w/, c => c.toUpperCase());
      return options.map(opt => 
        `<div><span class="cart-item-option-label">${capitalize(opt.name)}: </span><span class="cart-item-option-value">${capitalize(opt.value)}</span></div>`
      ).join('');
    }

    /**
     * Capture the initial state after size restoration
     */
    captureInitialState() {
      const variantSelects = this.drawer.querySelector('variant-selects');
      this.initialVariantId = variantSelects?.currentVariant?.id || this.productVariantId;
      this.initialSizeSelection = this.captureSizeSelection();
      
      // Store the US equivalent value for comparison across systems
      this.initialUSValue = this.getUSEquivalentValue();
    }

    /**
     * Attach listeners to size radio buttons and system tabs
     */
    attachSizeChangeListeners() {
      const sizeOptionsContainer = this.drawer.querySelector('#size-options');
      if (sizeOptionsContainer) {
        const radioInputs = sizeOptionsContainer.querySelectorAll('input[type="radio"]');
        radioInputs.forEach(radio => {
          radio.addEventListener('change', this.onSizeChange);
        });
      }

      const shoeSizeTabs = this.drawer.querySelector('shoe-size-tabs');
      if (shoeSizeTabs) {
        shoeSizeTabs.addEventListener('size-system-changed', this.onSizeChange);
      }
    }

    /**
     * Handle size selection changes
     */
    onSizeChange() {
      this.checkIfSelectionChanged();
    }

    /**
     * Check if current selection differs from initial state
     */
    checkIfSelectionChanged() {
      const variantSelects = this.drawer.querySelector('variant-selects');
      const currentVariantId = variantSelects?.currentVariant?.id || this.productVariantId;
      const currentSizeSelection = this.captureSizeSelection();
      const currentUSValue = this.getUSEquivalentValue();

      // Check if variant changed
      const variantChanged = currentVariantId !== this.initialVariantId;
      
      // Check if the actual size changed (compare US values across systems)
      const sizeChanged = this.initialUSValue && currentUSValue && 
        (this.initialUSValue !== currentUSValue);

      // Check if current variant is out of stock
      const currentVariant = variantSelects?.currentVariant;
      const isOutOfStock = currentVariant && !currentVariant.available;

      // Enable button only if changed AND in stock
      const hasChanged = variantChanged || sizeChanged;
      
      if (isOutOfStock) {
        this.setUpdateButtonState(false, true);
      } else {
        this.setUpdateButtonState(hasChanged, false);
      }
    }

    /**
     * Enable or disable the update button with visual feedback
     */
    setUpdateButtonState(enabled, outOfStock = false) {
      if (!this.updateButton) return;

      if (!this.updateButton.dataset.originalText) {
        this.updateButton.dataset.originalText = this.updateButton.textContent.trim();
      }

      if (outOfStock) {
        this.updateButton.disabled = true;
        this.updateButton.classList.add('disabled');
        this.updateButton.style.backgroundColor = '#e5e5e5';
        this.updateButton.style.color = '#9ca3af';
        this.updateButton.style.cursor = 'not-allowed';
        this.updateButton.style.pointerEvents = 'none';
        this.updateButton.style.opacity = '1';
        this.updateButton.textContent = 'Out of Stock';
      } else if (enabled) {
        this.updateButton.disabled = false;
        this.updateButton.classList.remove('disabled');
        this.updateButton.style.backgroundColor = '#000000';
        this.updateButton.style.color = '#ffffff';
        this.updateButton.style.cursor = 'pointer';
        this.updateButton.style.pointerEvents = 'auto';
        this.updateButton.style.opacity = '1';
        this.updateButton.innerHTML = `
          <span>Update</span>
          <span class="loading-overlay">
            <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="spinner-path" fill="none" stroke-width="6" cx="33" cy="33" r="30" stroke="var(--color-accent)"></circle>
            </svg>
          </span>
        `;
      } else {
        this.updateButton.disabled = true;
        this.updateButton.classList.add('disabled');
        this.updateButton.style.backgroundColor = '#e5e5e5';
        this.updateButton.style.color = '#9ca3af';
        this.updateButton.style.cursor = 'not-allowed';
        this.updateButton.style.pointerEvents = 'none';
        this.updateButton.style.opacity = '1';
        this.updateButton.textContent = 'Update';
      }
    }

    /**
     * Get the US equivalent value for the currently selected size
     */
    getUSEquivalentValue() {
      const checkedSizeOption = this.drawer.querySelector('#size-options input[type=radio]:checked');
      if (!checkedSizeOption) return null;

      const shoeSizeTabs = this.drawer.querySelector('shoe-size-tabs');
      
      if (shoeSizeTabs) {
        const label = checkedSizeOption.nextElementSibling;
        if (label && label.dataset.us) {
          return label.dataset.us;
        }
      }
      
      return checkedSizeOption.value;
    }

    /**
     * Restore the size selection state from cart item properties
     */
    restoreSizeSelection() {
      if (!this.productOption || this.productOption.length === 0) return;

      const sizeOption = this.productOption.find(opt => 
        opt.name.toLowerCase().includes('size')
      );

      if (!sizeOption) return;

      const sizeValue = sizeOption.value;
      const shoeSizeTabs = this.drawer.querySelector('shoe-size-tabs');
      const sizeOptionsContainer = this.drawer.querySelector('#size-options');
      
      if (shoeSizeTabs) {
        this.restoreShoeSize(sizeValue, shoeSizeTabs, sizeOptionsContainer);
      } else {
        this.restoreRegularSize(sizeValue, sizeOptionsContainer);
      }
    }

    /**
     * Restore shoe size selection with correct system tab
     */
    restoreShoeSize(sizeValue, shoeSizeTabs, container) {
      if (!container) return;

      const storedSizeSystem = this.productOption.find(opt => 
        opt.name === '_selectedSizeSystem'
      );

      let targetSystem = 'us';
      let targetValue = sizeValue;

      if (storedSizeSystem && storedSizeSystem.value) {
        const parts = storedSizeSystem.value.trim().split(/\s+/);
        if (parts.length >= 2) {
          targetSystem = parts[0].toLowerCase();
          targetValue = parts.slice(1).join(' ');
        }
      }

      const tabs = shoeSizeTabs.querySelectorAll('.size-tab');
      const targetTab = Array.from(tabs).find(tab => 
        tab.dataset.system === targetSystem
      );

      if (targetTab) {
        tabs.forEach(t => t.classList.remove('active'));
        targetTab.classList.add('active');
        
        if (shoeSizeTabs.switchSystem) {
          shoeSizeTabs.switchSystem(targetTab);
        }

        requestAnimationFrame(() => {
          this.selectMatchingSize(container, targetValue, targetSystem);
        });
      } else {
        this.selectMatchingSize(container, targetValue, targetSystem);
      }
    }

    /**
     * Select the matching size radio button
     */
    selectMatchingSize(container, sizeValue, system = 'us') {
      const radioInputs = container.querySelectorAll('input[type="radio"]');
      
      for (const radio of radioInputs) {
        const label = radio.nextElementSibling;
        if (!label) continue;

        const displayedValue = label.textContent.trim();
        const usValue = label.dataset.us;

        if (displayedValue === sizeValue || 
            (system === 'us' && usValue === sizeValue)) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          
          radio.closest('.variant-input')?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
          
          break;
        }
      }
    }

    /**
     * Restore regular (non-shoe) size selection
     */
    restoreRegularSize(sizeValue, container) {
      if (!container) return;

      const radioInputs = container.querySelectorAll('input[type="radio"]');
      
      for (const radio of radioInputs) {
        if (radio.value === sizeValue) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          
          radio.closest('.variant-input')?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
          
          break;
        }
      }
    }

    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (!sectionInnerHTML) return;

      this.drawer.querySelector('#Cart-Item-Drawer-Content').innerHTML = sectionInnerHTML;

      const jsFiles = this.drawer.querySelectorAll('#Cart-Item-Drawer-Content script');
      if (jsFiles.length > 0) {
        const head = document.head;
        jsFiles.forEach((jsFile) => {
          const script = document.createElement('script');
          script.src = jsFile.src;
          head.appendChild(script);
        });
      }

      this.updateButton = this.drawer.querySelector('.cart-item-update-btn');
      const variantSelects = this.drawer.querySelector('variant-selects');

      if (variantSelects) {
        variantSelects.addEventListener('change', this.onCartItemVariantChange);
      }

      if (this.updateButton) {
        this.updateButton.addEventListener('click', this.handleUpdateClick);
      }

      const closeButton = this.drawer.querySelector('.side-panel-close');
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          this.drawer.classList.remove('active');
          this.body.classList.remove('open-quick-view', 'open-cc');
        });
      }

      setTimeout(() => {
        if (Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
        if (window.ProductModel) window.ProductModel.loadShopifyXR();
      }, 300);

      this.body.classList.add('open-cc', 'open-quick-view');
      this.drawer.classList.add('active');
      this.drawer.querySelector('.side-panel-close').focus();

      dispatchCustomEvent('quick-view:open', { productUrl: href, productHandle });
    }

    onCartItemVariantChange(e) {
      const variantSelects = this.drawer.querySelector('variant-selects');

      if (!variantSelects) return;
      const currentVariant = variantSelects.currentVariant;

      if (!currentVariant) return;

      if (this.updateButton) {
        this.updateButton.dataset.newVariantId = currentVariant.id;
      }
      
      this.checkIfSelectionChanged();
    }

    async handleUpdateClick(e) {
      e.preventDefault();
      
      if (this.updateButton.disabled || this.updateButton.classList.contains('disabled')) {
        return;
      }
      
      if (this.updateButton.classList.contains('loading')) return;

      const newVariantId = this.updateButton.dataset.newVariantId || this.productVariantId;
      const quantity = this.drawer.querySelector('[name="quantity"]')?.value || this.productQuantity;
      if (!newVariantId) return;

      this.updateButton.classList.add('loading');

      // Capture the selected size information
      const sizeData = this.captureSizeSelection();

      // Get variant data for inventory check
      const variantSelects = this.drawer.querySelector('variant-selects');
      const currentVariant = variantSelects?.currentVariant;

      try {
        // Remove old variant
        await fetch(`${theme.routes.cart_update_url || '/cart/update.js'}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            updates: { [this.productVariantId]: 0 }
          })
        });

        const sections = this.getSectionsToRender().map(s => s.section);
        const formData = new FormData();
        formData.append('id', newVariantId);
        formData.append('quantity', quantity);
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);

        // Add custom properties (non-size options)
        if (this.productOption && this.productOption.length > 0) {
          this.productOption.forEach(opt => {
            if (!opt.name.toLowerCase().includes('size') && 
                opt.name !== '_selectedSizeSystem') {
              formData.append(`properties[${opt.name}]`, opt.value);
            }
          });
        }

        // Add the captured size data
        if (sizeData.fullDisplay) {
          formData.append('properties[_selectedSizeSystem]', sizeData.fullDisplay);
        }

        const addResponse = await fetch(`${theme.routes.cart_add_url || '/cart/add.js'}`, {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          }
        });

        const addData = await addResponse.json();

        // Check for 422 inventory limit
        if (addData.status === 422 || addResponse.status === 422) {
          // Close modal first
          this.drawer.classList.remove('active');
          this.body.classList.remove('open-quick-view', 'open-cc');
          
          // Then handle the inventory limit and show notification
          const result = await this.handleInventoryLimitFromAddResponse(
            addData, 
            newVariantId, 
            parseInt(quantity), 
            currentVariant
          );
          
          if (result.status === this.UPDATE_RESULT.INVENTORY_LIMIT) {
            return;
          }
        }

        // Success - get fresh sections
        let sectionsResponse;
        if (addData && addData.sections) {
          sectionsResponse = addData;
        } else {
          const sectionsToRender = sections.join(',');
          const response = await fetch(`/?sections=${sectionsToRender}&sections_url=${window.location.pathname}`, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          sectionsResponse = await response.json();
        }

        if (sectionsResponse) {
          this.renderContents(sectionsResponse);
          dispatchCustomEvent('cart:updated', { cart: sectionsResponse });

          // Update dropdown for new variant after DOM updates
          if (currentVariant && currentVariant.inventory_quantity !== undefined) {
            setTimeout(() => {
              this.updateQuantityDropdownForVariant(newVariantId, currentVariant.inventory_quantity);
            }, 300);
          }

          // Close modal first
          this.drawer.classList.remove('active');
          this.body.classList.remove('open-quick-view', 'open-cc');

          // Show success notification after modal closes
          setTimeout(() => {
            this.showMessage('success', 'Success updated the size');
          }, 100);
        }
      } catch (err) {
        console.error('Cart update failed:', err);
        
        // Close modal first
        this.drawer.classList.remove('active');
        this.body.classList.remove('open-quick-view', 'open-cc');
        
        // Show error notification after modal closes
        setTimeout(() => {
          this.showMessage('error', 'Failed to update cart. Please try again.');
        }, 100);
      } finally {
        this.updateButton.classList.remove('loading');
      }
    }

    /**
     * Handle 422 response from add.js
     */
    async handleInventoryLimitFromAddResponse(addData, variantId, requestedQty, variantData) {
      const message = addData.message || addData.description || '';
      const match = message.match(/(?:Only|add)\s+(\d+)\s+(?:items?|of)/i);
      const availableQuantity = match ? parseInt(match[1]) : null;

      if (availableQuantity !== null && availableQuantity > 0) {
        // Refresh cart to show partial add
        await this.refreshCart();

        const productTitle = variantData?.product?.title || variantData?.title || 'This item';
        const variantTitle = variantData?.title;
        
        let itemDescription = productTitle;
        if (variantTitle && variantTitle !== 'Default Title') {
          itemDescription += ` (${variantTitle})`;
        }

        const warningMessage = `Maximum available quantity reached! Only ${availableQuantity} ${availableQuantity === 1 ? 'unit was' : 'units were'} added to cart for ${itemDescription}.`;
        
        // Show warning notification with delay to ensure it appears after modal closes
        setTimeout(() => {
          this.showMessage('warning', warningMessage);
        }, 100);

        // Update dropdown after refresh
        setTimeout(() => {
          this.updateQuantityDropdownForVariant(variantId, availableQuantity);
        }, 300);

        return { status: this.UPDATE_RESULT.INVENTORY_LIMIT, quantity: availableQuantity };
      } else {
        await this.refreshCart();
        
        // Show error notification with delay
        setTimeout(() => {
          this.showMessage('error', message || 'Unable to update due to stock limitations.');
        }, 100);
        
        return { status: this.UPDATE_RESULT.INVENTORY_LIMIT };
      }
    }

    /**
     * Update quantity dropdown for a specific variant
     */
    async updateQuantityDropdownForVariant(variantId, inventoryQty) {
      const dropdown = document.querySelector(
        `quantity-dropdown select[data-variant-id="${variantId}"]`
      );
      
      if (!dropdown) {
        console.warn('Dropdown not found for variant:', variantId);
        return;
      }
      
      const qtyComponent = dropdown.closest('quantity-dropdown');
      if (qtyComponent && typeof qtyComponent.updateDropdownMaxQuantity === 'function') {
        qtyComponent.updateDropdownMaxQuantity(inventoryQty);
        console.log(`✅ Dropdown updated: variant ${variantId}, max inventory ${inventoryQty}`);
      }
    }

    /**
     * Refresh cart sections
     */
    async refreshCart() {
      try {
        const sections = this.getSectionsToRender().map((section) => section.section);
        const sectionsToRender = sections.join(',');
        
        const sectionsResponse = await fetch(
          `/?sections=${sectionsToRender}&sections_url=${window.location.pathname}`,
          { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
        );
        
        if (sectionsResponse.ok) {
          const sectionsData = await sectionsResponse.json();
          this.renderContents({ sections: sectionsData });
        }
      } catch (error) {
        console.error('Error refreshing cart:', error);
      }
    }

    /**
     * Show message notification
     */
    showMessage(type, message) {
      const appMessage = document.querySelector('app-message');
      if (appMessage && typeof appMessage.show === 'function') {
        appMessage.show(type, message);
      } else {
        console[type === 'error' ? 'error' : 'log'](`[${type.toUpperCase()}] ${message}`);
        this.showFallbackNotification(type, message);
      }
    }

    /**
     * Fallback notification system with mobile close button
     */
    showFallbackNotification(type, message) {
      const existingNotification = document.querySelector('.cart-update-notification');
      if (existingNotification) {
        existingNotification.remove();
      }

      const notification = document.createElement('div');
      notification.className = `cart-update-notification cart-update-notification--${type}`;
      
      // Create icon container
      const iconContainer = document.createElement('div');
      iconContainer.className = 'notification-icon';
      Object.assign(iconContainer.style, {
        flexShrink: '0',
        display: 'flex',
        alignItems: 'center'
      });
      
      // Icon colors based on type
      const iconColors = {
        success: '#10b981',
        warning: '#f59e0b',
        error: '#dc2626'
      };
      
      const iconColor = iconColors[type] || iconColors.success;
      
      // Add appropriate icon based on type
      if (type === 'success') {
        iconContainer.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.9397 7.65173C21.4493 7.19745 21.3846 6.3812 20.7695 6.085C19.5086 5.47782 18.11 5.10276 16.6259 5.01815C10.5606 4.67238 5.36343 9.30895 5.01766 15.3742C4.67189 21.4395 9.30847 26.6367 15.3737 26.9825C21.439 27.3283 26.6362 22.6917 26.982 16.6264C27.0133 16.0768 27.0038 15.5344 26.9559 15.002C26.8841 14.2033 25.9447 13.9072 25.3461 14.4408C25.0817 14.6765 24.9555 15.0275 24.9794 15.3809C25.0046 15.7529 25.007 16.1306 24.9852 16.5126C24.7023 21.4751 20.4501 25.2686 15.4876 24.9857C10.5251 24.7028 6.73151 20.4506 7.01442 15.4881C7.29732 10.5256 11.5496 6.732 16.5121 7.01491C17.6607 7.08039 18.7466 7.3585 19.7339 7.80884C20.1347 7.99165 20.6109 7.94484 20.9397 7.65173Z" fill="#457030"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M27.2073 7.2935C27.5977 7.68419 27.5974 8.31736 27.2068 8.70772L16.2308 19.6745C15.7825 20.1224 15.0493 20.0999 14.6294 19.6251L11.2767 15.8347C10.9108 15.4211 10.9495 14.7891 11.3632 14.4232C11.7769 14.0573 12.4088 14.096 12.7747 14.5097L15.4938 17.5837L25.7931 7.29291C26.1838 6.90255 26.817 6.90282 27.2073 7.2935Z" fill="#457030"/>
          </svg>
        `;
      } else if (type === 'warning') {
        iconContainer.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="${iconColor}"/>
          </svg>
        `;
      } else if (type === 'error') {
        iconContainer.innerHTML = `
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="${iconColor}"/>
          </svg>
        `;
      }
      
      // Create message container
      const messageContainer = document.createElement('div');
      messageContainer.className = 'notification-message';
      messageContainer.textContent = message;
      Object.assign(messageContainer.style, {
        flex: '1 0 0',
        fontSize: '14px',
        lineHeight: '1.5',
        fontWeight: '500',
        color: '#000000'
      });
      
      // Create close button (mobile only)
      const closeButton = document.createElement('button');
      closeButton.className = 'notification-close-btn';
      closeButton.setAttribute('aria-label', 'Close notification');
      closeButton.innerHTML = `
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 5L5 15M5 5L15 15" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round"/>
        </svg>
      `;
      Object.assign(closeButton.style, {
        display: 'none',
        background: 'transparent',
        border: 'none',
        padding: '0',
        cursor: 'pointer',
        flexShrink: '0',
        width: '20px',
        height: '20px',
        alignItems: 'center',
        justifyContent: 'center'
      });
      
      // Show close button only on mobile (768px and below)
      const mediaQuery = window.matchMedia('(max-width: 768px)');
      if (mediaQuery.matches) {
        closeButton.style.display = 'flex';
      }
      
      // Listen for viewport changes
      mediaQuery.addEventListener('change', (e) => {
        closeButton.style.display = e.matches ? 'flex' : 'none';
      });
      
      // Close notification when button is clicked
      let autoCloseTimeout;
      closeButton.addEventListener('click', () => {
        clearTimeout(autoCloseTimeout);
        notification.style.animation = 'slideOutRight 0.3s ease-out';
        setTimeout(() => notification.remove(), 300);
      });
      
      Object.assign(notification.style, {
        position: 'fixed',
        top: '20px',
        right: '20px',
        display: 'flex',
        padding: '8px',
        alignItems: 'flex-start',
        gap: '4px',
        flex: '1 0 0',
        border: '1px solid #E1E1E1',
        background: '#FFFFFF',
        boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.08)',
        zIndex: '10000',
        maxWidth: '400px',
        animation: 'slideInRight 0.3s ease-out'
      });

      notification.appendChild(iconContainer);
      notification.appendChild(messageContainer);
      notification.appendChild(closeButton);
      document.body.appendChild(notification);

      autoCloseTimeout = setTimeout(() => {
        notification.style.animation = 'slideOutRight 0.3s ease-out';
        setTimeout(() => notification.remove(), 300);
      }, 5000);
    }

    /**
     * Capture the currently selected size with system information
     */
    captureSizeSelection() {
      const result = {
        fullDisplay: '',
        rawValue: ''
      };

      const checkedSizeOption = this.drawer.querySelector('#size-options input[type=radio]:checked');
      if (!checkedSizeOption) return result;

      const shoeSizeTabs = this.drawer.querySelector('shoe-size-tabs');
      
      if (shoeSizeTabs) {
        const selectedSizeTab = shoeSizeTabs.querySelector('.size-tab.active');
        
        if (selectedSizeTab) {
          const selectedSizeSystem = selectedSizeTab.textContent.trim().toUpperCase();
          const label = checkedSizeOption.nextElementSibling;
          let selectedSizeValue = '';
          
          if (label) {
            selectedSizeValue = label.textContent.trim();
          }
          
          if (!selectedSizeValue && checkedSizeOption.value) {
            selectedSizeValue = checkedSizeOption.value;
          }
          
          if (selectedSizeValue) {
            result.fullDisplay = `${selectedSizeSystem} ${selectedSizeValue}`;
            result.rawValue = selectedSizeValue;
          }
        }
      } else {
        result.rawValue = checkedSizeOption.value;
        result.fullDisplay = checkedSizeOption.value;
      }

      return result;
    }

    getSectionsToRender() {
      return [
        { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
        { id: 'Order-Summary', section: 'order-summary', selector: '.order-summary__wrapper' },
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' },
        { id: 'cart-item__quantity', section: 'order-summary', selector: '.cart-header__item-count' },
      ];
    }

    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section) => {
        const container = document.getElementById(section.id);
        if (!container) return;

        const elementToReplace = container.querySelector(section.selector) || container;
        const html = new DOMParser()
          .parseFromString(parsedState.sections[section.section], 'text/html')
          .querySelector(section.selector)?.innerHTML;

        if (html) elementToReplace.innerHTML = html;
      });
    }
  }

  customElements.define('cart-item-quick-view', CartItemQuickView);

  // Add CSS animations if not already present
  if (!document.querySelector('#cart-update-animations')) {
    const style = document.createElement('style');
    style.id = 'cart-update-animations';
    style.textContent = `
      @keyframes slideInRight {
        from {
          transform: translateX(100%);
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      @keyframes slideOutRight {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(100%);
          opacity: 0;
        }
      }
      .cart-item-quick-view.loading {
        opacity: 0.6;
        pointer-events: none;
      }
    `;
    document.head.appendChild(style);
  }
}

class ShoeSizeTabs extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.tabs = this.querySelectorAll('.size-tab');
    this.labels = this.querySelectorAll('label[data-us]');

    this.mappings = {
      uk: this.parseMapping(this.dataset.uk),
      eu: this.parseMapping(this.dataset.eu),
    };
    
    this.bindEvents();
  }

  parseMapping(raw) {
    if (!raw) return {};
    return raw
      .split('\n')
      .map(line => line.split(':').map(s => s.trim()))
      .filter(parts => parts.length === 2 && parts[0] && parts[1])
      .reduce((map, [us, other]) => {
        map[us] = other;
        return map;
      }, {});
  }

  bindEvents() {
    if (!this.tabs.length || !this.labels.length) return;

    this.tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.switchSystem(tab);
      });
    });
  }

  switchSystem(tab) {
    if (!tab) return;

    this.tabs.forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
    
    const system = tab.dataset.system;
    
    this.labels.forEach(label => {
      const usValue = label.dataset.us;
      if (!usValue) return;

      if (system === 'us') {
        label.innerHTML = `<span>${usValue}</span>`;
      } else {
        const mappedValue = this.mappings[system]?.[usValue];
        label.innerHTML = `<span>${mappedValue || usValue}</span>`;
      }
    });

    // Dispatch event for external listeners
    this.dispatchEvent(new CustomEvent('size-system-changed', {
      detail: { system },
      bubbles: true
    }));
  }
}

customElements.define('shoe-size-tabs', ShoeSizeTabs);

class ScrollProgressBar extends HTMLElement {
  constructor() {
    super();
    this.container = null;
    this.progressBar = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Get the target container to track
    const targetSelector = this.getAttribute('data-target');
    if (!targetSelector) {
      console.error('ScrollProgressBar: data-target attribute is required');
      return;
    }

    this.container = document.querySelector(targetSelector);
    if (!this.container) {
      console.error(`ScrollProgressBar: Target element "${targetSelector}" not found`);
      return;
    }

    // Create progress bar structure
    this.createProgressBar();
    
    // Bind update function
    this.updateProgress = this.updateProgress.bind(this);
    
    // Add event listeners
    this.container.addEventListener('scroll', this.updateProgress);
    window.addEventListener('resize', this.updateProgress);
    
    // Initial update
    this.updateProgress();
  }

  createProgressBar() {
    // Create wrapper
    const wrapper = document.createElement('div');
    wrapper.className = 'scroll-progress-wrapper';
    
    // Create progress bar
    this.progressBar = document.createElement('div');
    this.progressBar.className = 'scroll-progress-bar';
    
    wrapper.appendChild(this.progressBar);
    this.appendChild(wrapper);
  }

  updateProgress() {
    if (!this.container || !this.progressBar) return;
    
    const scrollLeft = this.container.scrollLeft;
    const scrollWidth = this.container.scrollWidth - this.container.clientWidth;
    const scrollPercentage = scrollWidth > 0 ? (scrollLeft / scrollWidth) * 100 : 0;
    
    this.progressBar.style.width = `${scrollPercentage}%`;
  }

  disconnectedCallback() {
    // Cleanup event listeners
    if (this.container) {
      this.container.removeEventListener('scroll', this.updateProgress);
    }
    window.removeEventListener('resize', this.updateProgress);
  }
}

// Register the custom element
if (!customElements.get('scroll-progress-bar')) {
  customElements.define('scroll-progress-bar', ScrollProgressBar);
}



// ============================================
// SLIDING INDICATOR BAR (Fixed width, changes position)
// ============================================
class ScrollIndicatorBar extends HTMLElement {
  constructor() {
    super();
    this.container = null;
    this.indicatorBar = null;
    this.wrapper = null;
    this.totalItems = 0;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    const targetSelector = this.getAttribute('data-target');
    if (!targetSelector) {
      console.error('ScrollIndicatorBar: data-target attribute is required');
      return;
    }

    this.container = document.querySelector(targetSelector);
    if (!this.container) {
      console.error(`ScrollIndicatorBar: Target element "${targetSelector}" not found`);
      return;
    }

    // Count total scrollable items
    this.countItems();
    
    if (this.totalItems === 0) {
      console.warn('ScrollIndicatorBar: No items found');
      return;
    }
    
    // Create indicator bar structure
    this.createIndicatorBar();
    
    // Bind update functions
    this.updateIndicator = this.updateIndicator.bind(this);
    this.handleResize = this.handleResize.bind(this);
    
    // Add event listeners
    this.container.addEventListener('scroll', this.updateIndicator);
    window.addEventListener('resize', this.handleResize);
    
    // Initial update with slight delay to ensure DOM is ready
    setTimeout(() => this.updateIndicator(), 100);
  }

  countItems() {
    const itemSelector = this.getAttribute('data-item-selector');
    
    if (itemSelector) {
      this.totalItems = this.container.querySelectorAll(itemSelector).length;
    } else {
      this.totalItems = this.container.children.length;
    }
  }

  createIndicatorBar() {
    this.wrapper = document.createElement('div');
    this.wrapper.className = 'scroll-indicator-wrapper';
    
    this.indicatorBar = document.createElement('div');
    this.indicatorBar.className = 'scroll-indicator-bar';
    
    this.updateIndicatorWidth();
    
    this.wrapper.appendChild(this.indicatorBar);
    this.appendChild(this.wrapper);
  }

  updateIndicatorWidth() {
    if (this.totalItems > 0 && this.indicatorBar) {
      const indicatorWidth = (100 / this.totalItems);
      this.indicatorBar.style.width = `${indicatorWidth}%`;
    }
  }

  handleResize() {
    this.countItems();
    this.updateIndicatorWidth();
    this.updateIndicator();
  }

  updateIndicator() {
    if (!this.container || !this.indicatorBar || !this.wrapper || this.totalItems === 0) return;
    
    const scrollLeft = this.container.scrollLeft;
    const containerWidth = this.container.clientWidth;
    const scrollWidth = this.container.scrollWidth;
    const maxScroll = scrollWidth - containerWidth;
    
    if (maxScroll <= 0) {
      // Not scrollable
      this.indicatorBar.style.left = '0%';
      return;
    }
    
    // Calculate scroll percentage (0 to 1)
    const scrollPercentage = scrollLeft / maxScroll;
    
    // Calculate the available space for the indicator to move
    const indicatorWidth = (100 / this.totalItems);
    const availableSpace = 100 - indicatorWidth;
    
    // Calculate position (0% to availableSpace%)
    const position = scrollPercentage * availableSpace;
    
    // Use left position instead of transform
    this.indicatorBar.style.left = `${position}%`;
  }

  disconnectedCallback() {
    // Cleanup event listeners properly
    if (this.container) {
      this.container.removeEventListener('scroll', this.updateIndicator);
    }
    window.removeEventListener('resize', this.handleResize);
  }
}

// Register the custom element
if (!customElements.get('scroll-indicator-bar')) {
  customElements.define('scroll-indicator-bar', ScrollIndicatorBar);
}
